google.maps.event.addDomListener(window, "load", initMap);

function initMap() {
  let assetsUrl = $("#js-assets-url").attr("value");

  const options = {
    clickableIcons: true,
    disableDoubleClickZoom: false,
    draggable: true,
    fullscreenControl: false,
    keyboardShortcuts: true,
    mapMaker: true,
    mapTypeControl: false,
    mapTypeControlOptions: {
      text: "Default (depends on viewport size etc.)",
      style: 0,
    },
    mapTypeId: "roadmap",
    rotateControl: true,
    scaleControl: true,
    scrollwheel: true,
    streetViewControl: false,
    styles: [
      {
        featureType: "administrative.land_parcel",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "landscape.man_made",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            hue: "#f49935",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            hue: "#fad959",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            hue: "#a1cdfc",
          },
          {
            saturation: 30,
          },
          {
            lightness: 49,
          },
        ],
      },
    ],
    zoom: 16,
    zoomControl: true,
  };

  let mapCanvas;
  let mapLatLng;
  let mapOptions;
  let map;

  let mapArray = [
    {
      canvas: "js-map-main",
      lat: 35.72934,
      lng: 139.718593,
    },
    {
      canvas: "js-map-osaka",
      lat: 34.6638586,
      lng: 135.5008054,
    },
    {
      canvas: "js-map-nagoya",
      lat: 35.174789,
      lng: 136.883443,
    },
    {
      canvas: "js-map-yokohama",
      lat: 35.4580329,
      lng: 139.6277956,
    },
  ];

  $.each(mapArray, (index, value) => {
    mapCanvas = document.getElementById(value.canvas);
    mapLatLng = new google.maps.LatLng(value.lat, value.lng);
    mapOptions = {
      center: mapLatLng,
    };

    map = new google.maps.Map(mapCanvas, mapOptions);
    map.setOptions(options);

    new google.maps.Marker({
      icon: assetsUrl + "images/map-icon.png",
      position: mapLatLng,
      map: map,
    });
  });
}
